import random from 'toxilibs/random.js'
import nGramsCommons from './commons/ngrams.js'
import Level from '../core/level.js'

const level = new Level({
    name: 'ngrams_cissors_2',
    dependencies: [
        'levels/ngrams_cissors_1'
    ]
})

const {
    createQuestion,
    cutAndMysteryGram,
    cutAndMysteryLetter
} = nGramsCommons



level.addQuestion({
    generator: function (q) {
        let word = random.unmistakableLetters(4) +
            ' ' + random.unmistakableLetters(4)

        createQuestion(q, cutAndMysteryGram, {word, n: 2, pos: 3})
    }
})


level.addQuestion({
    generator: function (q) {
        let word = random.unmistakableLetters(random.intBetween(7, 10))

        createQuestion(q, cutAndMysteryLetter, {word, n: 2})
    }
})





export default level

